/** Strings for headless Clerk auth routes (`/login`, `/signin`, `/signup`). */
export const clerkAuthTranslations = {
  fr: {
    'clerkAuth.signInTitle': 'Connexion',
    'clerkAuth.signUpTitle': 'Créer un compte',
    'clerkAuth.email': 'Adresse courriel',
    'clerkAuth.emailRequired': 'Veuillez saisir votre adresse courriel.',
    'clerkAuth.password': 'Mot de passe',
    'clerkAuth.signInSubmit': 'Se connecter',
    'clerkAuth.signUpSubmit': 'Continuer',
    'clerkAuth.verificationTitle': 'Vérification',
    'clerkAuth.verificationHint':
      'Un code a été envoyé à votre adresse. Saisissez-le ci-dessous.',
    'clerkAuth.codeLabel': 'Code de vérification',
    'clerkAuth.verifySubmit': 'Vérifier',
    'clerkAuth.resendCode': 'Renvoyer le code',
    'clerkAuth.loading': 'Chargement…',
    'clerkAuth.noAccount': 'Pas encore de compte ?',
    'clerkAuth.signUpLink': 'S’inscrire',
    'clerkAuth.hasAccount': 'Déjà un compte ?',
    'clerkAuth.signInLink': 'Se connecter',
    'clerkAuth.securedBy': 'Sécurisé par',
    'clerkAuth.clientTrustTitle': 'Confirmer votre identité',
    'clerkAuth.clientTrustHint':
      'Un code a été envoyé à votre courriel pour confirmer cet appareil.',
    'clerkAuth.errorSecondFactorUnsupported':
      'Une étape de vérification supplémentaire est requise (non prise en charge ici).',
    'clerkAuth.errorSignInIncomplete': 'La connexion est incomplète. Réessayez.',
    'clerkAuth.errorInvalidOtp': 'Le code est invalide ou a expiré.',
    'clerkAuth.errorSignUpIncomplete': "L'inscription n'est pas terminée. Vérifiez le code ou réessayez.",
    'clerkAuth.loginBackdropLead': 'Pourvoirie',
    'clerkAuth.loginBackdropAccent': 'Pignon Rouge',
    'clerkAuth.loginBackdropSubtitle':
      'Connexion sécurisée à votre espace : réservations, profil et offres.',
    'clerkAuth.signInDescription': 'Entrez vos identifiants pour accéder à votre compte.',
    'clerkAuth.signInVerifyDescription': 'Saisissez le code envoyé à votre adresse courriel.',
    'clerkAuth.signInWithPassword': 'Mot de passe',
    'clerkAuth.signInWithEmailCode': 'Code par courriel',
    'clerkAuth.sendVerificationCode': 'Envoyer le code',
    'clerkAuth.errorEmailCodeUnsupported':
      'La connexion par code courriel n’est pas disponible pour cette adresse. Utilisez le mot de passe ou contactez le support.',
    'clerkAuth.backToCredentials': 'Retour à la connexion',
    'clerkAuth.signUpAddressRequired':
      'Veuillez remplir le numéro civique, la rue, la ville, la province, le code postal et le pays.',
    'clerkAuth.errorAddressSave':
      'Impossible d’enregistrer l’adresse. Réessayez ou ouvrez une session plus tard dans les paramètres.',
    'clerkAuth.signUpAddressSection': 'Adresse postale',
    'clerkAuth.signUpStreetNumber': 'Numéro',
    'clerkAuth.signUpAptNumber': 'App. / suite (optionnel)',
    'clerkAuth.signUpStreet': 'Rue',
    'clerkAuth.signUpCity': 'Ville',
    'clerkAuth.signUpProvince': 'Province / État',
    'clerkAuth.signUpPostalCode': 'Code postal',
    'clerkAuth.signUpCountry': 'Pays',
    'clerkAuth.signUpAddressLabel': 'Adresse',
    'clerkAuth.signUpAddressPlaceholder': 'Ex. 123 rue Principale, Montréal QC H2X 1Y2',
    'clerkAuth.forgotPasswordTitle': 'Mot de passe oublié',
    'clerkAuth.forgotPasswordDescription':
      'Indiquez votre courriel : nous enverrons un code pour définir un nouveau mot de passe.',
    'clerkAuth.forgotPasswordSendCode': 'Envoyer le code',
    'clerkAuth.forgotPasswordResetTitle': 'Nouveau mot de passe',
    'clerkAuth.forgotPasswordResetHint': 'Saisissez le code reçu par courriel et votre nouveau mot de passe.',
    'clerkAuth.forgotPasswordSubmit': 'Enregistrer le mot de passe',
    'clerkAuth.forgotPasswordBack': '← Retour à la connexion',
    'clerkAuth.forgotPasswordUseDifferentEmail': 'Utiliser une autre adresse courriel',
    'clerkAuth.newPasswordLabel': 'Nouveau mot de passe',
    'clerkAuth.forgotPasswordLink': 'Mot de passe oublié ?',
    'clerkAuth.firstLoginNotice': 'Première connexion ? Un mot de passe temporaire vous a été attribué — réinitialisez-le pour définir le vôtre.',
    'clerkAuth.firstLoginResetCta': 'Réinitialiser mon mot de passe →',
    'clerkAuth.accountNotFound': 'Aucun compte trouvé pour cette adresse courriel.',
    'clerkAuth.accountNotFoundCta': 'Créer un compte →',
  },
  en: {
    'clerkAuth.signInTitle': 'Sign in',
    'clerkAuth.signUpTitle': 'Create account',
    'clerkAuth.email': 'Email address',
    'clerkAuth.emailRequired': 'Please enter your email address.',
    'clerkAuth.password': 'Password',
    'clerkAuth.signInSubmit': 'Sign in',
    'clerkAuth.signUpSubmit': 'Continue',
    'clerkAuth.verificationTitle': 'Verification',
    'clerkAuth.verificationHint': 'We sent a code to your email. Enter it below.',
    'clerkAuth.codeLabel': 'Verification code',
    'clerkAuth.verifySubmit': 'Verify',
    'clerkAuth.resendCode': 'Resend code',
    'clerkAuth.loading': 'Loading…',
    'clerkAuth.noAccount': 'No account yet?',
    'clerkAuth.signUpLink': 'Sign up',
    'clerkAuth.hasAccount': 'Already have an account?',
    'clerkAuth.signInLink': 'Sign in',
    'clerkAuth.securedBy': 'Secured by',
    'clerkAuth.clientTrustTitle': 'Verify your identity',
    'clerkAuth.clientTrustHint': 'We sent a code to your email to verify this device.',
    'clerkAuth.errorSecondFactorUnsupported':
      'An additional verification step is required (not supported on this screen).',
    'clerkAuth.errorSignInIncomplete': 'Sign-in could not be completed. Try again.',
    'clerkAuth.errorInvalidOtp': 'The code is invalid or has expired.',
    'clerkAuth.errorSignUpIncomplete': 'Sign-up is not complete. Check the code or try again.',
    'clerkAuth.loginBackdropLead': 'Welcome to',
    'clerkAuth.loginBackdropAccent': 'Pignon Rouge',
    'clerkAuth.loginBackdropSubtitle':
      'Secure sign-in to manage your bookings, profile, and offers.',
    'clerkAuth.signInDescription': 'Enter your credentials to access your account.',
    'clerkAuth.signInVerifyDescription': 'Enter the code sent to your email address.',
    'clerkAuth.signInWithPassword': 'Password',
    'clerkAuth.signInWithEmailCode': 'Email code',
    'clerkAuth.sendVerificationCode': 'Send verification code',
    'clerkAuth.errorEmailCodeUnsupported':
      'Email code sign-in is not available for this address. Use your password or contact support.',
    'clerkAuth.backToCredentials': 'Back to sign in',
    'clerkAuth.signUpAddressRequired':
      'Please fill in street number, street, city, province/state, postal code, and country.',
    'clerkAuth.errorAddressSave':
      'Could not save your address. Try again or update it later in settings.',
    'clerkAuth.signUpAddressSection': 'Mailing address',
    'clerkAuth.signUpStreetNumber': 'Number',
    'clerkAuth.signUpAptNumber': 'Apt / suite (optional)',
    'clerkAuth.signUpStreet': 'Street',
    'clerkAuth.signUpCity': 'City',
    'clerkAuth.signUpProvince': 'Province / state',
    'clerkAuth.signUpPostalCode': 'Postal code',
    'clerkAuth.signUpCountry': 'Country',
    'clerkAuth.signUpAddressLabel': 'Address',
    'clerkAuth.signUpAddressPlaceholder': 'e.g. 123 Main St, Montreal QC H2X 1Y2',
    'clerkAuth.forgotPasswordTitle': 'Forgot password',
    'clerkAuth.forgotPasswordDescription':
      'Enter your email — we will send a code so you can set a new password.',
    'clerkAuth.forgotPasswordSendCode': 'Send code',
    'clerkAuth.forgotPasswordResetTitle': 'New password',
    'clerkAuth.forgotPasswordResetHint': 'Enter the code from your email and your new password.',
    'clerkAuth.forgotPasswordSubmit': 'Save new password',
    'clerkAuth.forgotPasswordBack': '← Back to sign in',
    'clerkAuth.forgotPasswordUseDifferentEmail': 'Use a different email',
    'clerkAuth.newPasswordLabel': 'New password',
    'clerkAuth.forgotPasswordLink': 'Forgot password?',
    'clerkAuth.firstLoginNotice': 'First time logging in? A temporary password was set for you — reset it to choose your own.',
    'clerkAuth.firstLoginResetCta': 'Reset my password →',
    'clerkAuth.accountNotFound': 'No account found for this email address.',
    'clerkAuth.accountNotFoundCta': 'Create an account →',
  },
  zh: {
    'clerkAuth.signInTitle': '登录',
    'clerkAuth.signUpTitle': '创建账户',
    'clerkAuth.email': '电子邮箱',
    'clerkAuth.emailRequired': '请输入电子邮箱地址。',
    'clerkAuth.password': '密码',
    'clerkAuth.signInSubmit': '登录',
    'clerkAuth.signUpSubmit': '继续',
    'clerkAuth.verificationTitle': '验证',
    'clerkAuth.verificationHint': '我们已向您的邮箱发送验证码，请在下方输入。',
    'clerkAuth.codeLabel': '验证码',
    'clerkAuth.verifySubmit': '验证',
    'clerkAuth.resendCode': '重新发送验证码',
    'clerkAuth.loading': '加载中…',
    'clerkAuth.noAccount': '还没有账户？',
    'clerkAuth.signUpLink': '注册',
    'clerkAuth.hasAccount': '已有账户？',
    'clerkAuth.signInLink': '登录',
    'clerkAuth.securedBy': '安全由',
    'clerkAuth.clientTrustTitle': '验证身份',
    'clerkAuth.clientTrustHint': '我们已向您的邮箱发送验证码以验证此设备。',
    'clerkAuth.errorSecondFactorUnsupported': '需要额外的验证步骤（此页面暂不支持）。',
    'clerkAuth.errorSignInIncomplete': '登录未完成，请重试。',
    'clerkAuth.errorInvalidOtp': '验证码无效或已过期。',
    'clerkAuth.errorSignUpIncomplete': '注册未完成，请检查验证码或重试。',
    'clerkAuth.loginBackdropLead': '欢迎来到',
    'clerkAuth.loginBackdropAccent': 'Pignon Rouge',
    'clerkAuth.loginBackdropSubtitle': '安全登录以管理预订、个人资料和优惠。',
    'clerkAuth.signInDescription': '请输入凭据以登录账户。',
    'clerkAuth.signInVerifyDescription': '请输入发送到您邮箱的验证码。',
    'clerkAuth.signInWithPassword': '密码',
    'clerkAuth.signInWithEmailCode': '邮箱验证码',
    'clerkAuth.sendVerificationCode': '发送验证码',
    'clerkAuth.errorEmailCodeUnsupported': '此邮箱不支持验证码登录，请使用密码或联系支持。',
    'clerkAuth.backToCredentials': '返回登录',
    'clerkAuth.signUpAddressRequired': '请填写门牌号、街道、城市、省/州、邮编和国家。',
    'clerkAuth.errorAddressSave': '无法保存地址，请重试或稍后在设置中更新。',
    'clerkAuth.signUpAddressSection': '邮寄地址',
    'clerkAuth.signUpStreetNumber': '门牌号',
    'clerkAuth.signUpAptNumber': '单元 / 套房（选填）',
    'clerkAuth.signUpStreet': '街道',
    'clerkAuth.signUpCity': '城市',
    'clerkAuth.signUpProvince': '省 / 州',
    'clerkAuth.signUpPostalCode': '邮编',
    'clerkAuth.signUpCountry': '国家',
    'clerkAuth.signUpAddressLabel': '地址',
    'clerkAuth.signUpAddressPlaceholder': '例：某某路123号，蒙特利尔 QC H2X 1Y2',
    'clerkAuth.forgotPasswordTitle': '忘记密码',
    'clerkAuth.forgotPasswordDescription': '请输入邮箱，我们将发送验证码以便您设置新密码。',
    'clerkAuth.forgotPasswordSendCode': '发送验证码',
    'clerkAuth.forgotPasswordResetTitle': '新密码',
    'clerkAuth.forgotPasswordResetHint': '请输入邮件中的验证码和新密码。',
    'clerkAuth.forgotPasswordSubmit': '保存新密码',
    'clerkAuth.forgotPasswordBack': '← 返回登录',
    'clerkAuth.forgotPasswordUseDifferentEmail': '使用其他邮箱',
    'clerkAuth.newPasswordLabel': '新密码',
    'clerkAuth.forgotPasswordLink': '忘记密码？',
    'clerkAuth.firstLoginNotice': '首次登录？系统已为您设置了临时密码 — 请重置以设定您自己的密码。',
    'clerkAuth.firstLoginResetCta': '重置我的密码 →',
    'clerkAuth.accountNotFound': '未找到此邮箱对应的账户。',
    'clerkAuth.accountNotFoundCta': '创建账户 →',
  },
} as const;
